// App.tsx
import React from "react";
import "./styles/global.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import QuizSectionA from "./pages/QuizSectionA";
import QuizSectionB from "./pages/QuizSectionB";
import QuizResult from "./pages/QuizResult";
import CourseStudy from "./pages/CourseStudy";

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/quiz/section-a" element={<QuizSectionA />} />
        <Route path="/quiz/section-b" element={<QuizSectionB />} />
        <Route path="/quiz/result" element={<QuizResult />} />
        <Route path="course-study/:id" element={<CourseStudy />} />
      </Routes>
    </Router>
  );
};

export default App;
